export { default } from './MaxWidthWrapper';
export type { Props } from './MaxWidthWrapper';
